<template>
  <div
    class="start"
    data-testid="elem_u_003098"
  >
    <div
      class="content-block"
      data-testid="elem_u_003099"
    >
      <img
        class="map-image"
        src="@/assets/img/home/map.svg"
        alt="World map"
        data-testid="elem_u_003103"
      />

      <div class="map-content">
        <h3
          class="block-title"
          data-testid="elem_u_003100"
        >
          Start now!
        </h3>
        <p
          class="block-description"
          data-testid="elem_u_003101"
        >
          Join the UnzipVR affiliates team and start to earn big.
        </p>
        <UnzipButton
          :to="{ name: 'Signup' }"
          height="50"
          width="178"
          class="button-join"
          data-testid="elem_u_003102"
        >
          Join Today
        </UnzipButton>
      </div>
    </div>

    <div
      class="seo-wrapper"
      v-if="seoContent"
    >
      <div
        class="seo-text"
        v-html="seoContent"
        :class="seoInfoOpened ? 'seo-opened' : 'seo-closed'"
        data-testid="elem_u_003104"
      />
      <v-icon
        @click="seoInfoOpened = !seoInfoOpened"
        size="20"
        color="#8D8D8D"
        class="seo-toggle"
        data-testid="elem_u_003105"
      >
        {{ seoInfoOpened ? 'arrow_drop_up' : 'arrow_drop_down' }}
      </v-icon>
    </div>
  </div>
</template>

<script>
import api from '@/api/settings/admin/seo';

export default {
  data() {
    return {
      seoContent: null,
      seoInfoOpened: false,
    };
  },
  methods: {
    async getContent() {
      const seoSettings = await api.get();
      this.seoContent = seoSettings?.data?.content ?? '';
    },
  },
  async beforeCreate() {
    const seoData = await api.get();
    this.seoContent = seoData?.data?.content ?? '';
    document.title = seoData?.data?.title ?? 'Unzipvr Affiliates';

    const metaDescription = document.createElement('meta');
    metaDescription.name = 'description';
    metaDescription.content = seoData?.data?.description ?? '';
    if (metaDescription.content) {
      document.head.appendChild(metaDescription);
    }
  },
};
</script>

<style lang="scss" scoped>
.start {
  width: 100%;
  padding-top: 100px;
  padding-bottom: 50px;
  color: var(--color-grey-900);

  @media (max-width: 1660px) {
    padding-top: 50px;
  }

  @include sm-down {
    padding-top: 30px;
  }

  .content-block {
    display: flex;
    flex-direction: column;
    position: relative;
    margin-bottom: 50px;

    @include sm-down {
      margin-bottom: 0;
    }
  }

  .block-title {
    font-size: 42px;
    font-weight: 700;
    line-height: 49px;
    margin-bottom: 20px;

    @include md-down {
      font-size: 30px;
      line-height: 35px;
    }
    @include sm-down {
      font-size: 24px;
      line-height: 28px;
    }
  }

  .block-description {
    font-size: 20px;
    font-weight: 400;
    line-height: 23px;
    width: 376px;
    margin-bottom: 50px;

    @include md-down {
      width: 100%;
      font-size: 16px;
      line-height: 19px;
    }
  }

  .button-join {
    margin-bottom: 62px;
    @include md-down {
      margin-bottom: 40px;
    }

    @include sm-down {
      margin-bottom: 30px;
    }
  }

  .map-image {
    position: absolute;
    right: 0;
    height: 100%;
    max-height: 100%;
    width: auto;
    z-index: 0;

    @media (max-width: 1000px) {
      right: unset;
      left: 0;
    }
  }

  .map-content {
    position: relative;
    z-index: 10;
  }

  .seo-wrapper {
    height: fit-content;
    position: relative;
    p {
      margin: 0 !important;
    }
    .seo-toggle {
      position: absolute;
      bottom: 0;
      right: 0;
    }
  }
  .seo-text {
    font-size: 20px;
    font-weight: 400;
    line-height: 30px;
    color: var(--color-grey-600);
    height: fit-content;
    overflow: hidden;

    @include md-down {
      font-size: 16px;
      line-height: 24px;
    }

    &.seo-opened {
      max-height: fit-content;
    }
    &.seo-closed {
      max-height: 150px;
      @include md-down {
        max-height: 192px;
      }
      @include sm-down {
        max-height: 408px;
      }
    }
  }
}
</style>

<style lang="scss">
.seo-text {
  p {
    margin: 0;
  }
}
</style>
